import { render, staticRenderFns } from "./BriqMultiselectCustomLabel.vue?vue&type=template&id=6db08236&scoped=true&lang=pug&functional=true&"
var script = {}
import style0 from "./BriqMultiselectCustomLabel.vue?vue&type=style&index=0&id=6db08236&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6db08236",
  null
  
)

export default component.exports